var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExemptions = function SvgExemptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 1005,
    viewBox: "0 0 119 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5a4 4 0 0 1 4-4h111a4 4 0 0 1 4 4v94a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-94Z",
    fill: "#053249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5a3 3 0 0 1 3-3h108a3 3 0 0 1 3 3v91a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-91Z",
    fill: "#fff",
    stroke: "#053249",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.238 48.5 11 72.5v17a2 2 0 0 0 2 2h95a2 2 0 0 0 2-2v-65l-33.64 16-34.122 8Z",
    fill: "#99EDBA",
    stroke: "#99EDBA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.238 63.5 11 72.5v17a2 2 0 0 0 2 2h95a2 2 0 0 0 2-2V41L76.36 52.5l-34.122 11Z",
    fill: "#1C7CE5",
    stroke: "#1C7CE5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgExemptions;